module.exports = __webpack_public_path__ + "static/img/oppodcb1.5cb7388a.png";